export type DemoAction = 'click' | 'longpress';

export type TutorialStep =
  | { kind: 'intro'; mascot: string }
  | {
      kind: 'demo-sticker';
      mascot: string;
      initialCount: number;
      expect: DemoAction[];
      hint?: string;
      attentionPulse?: boolean;
    }
  | {
      kind: 'highlight';
      mascot: string;
      tab: 'album' | 'trocas' | 'amigos';
      targetId: string;
    }
  | { kind: 'navigate'; mascot: string; tab: 'album' | 'trocas' | 'amigos' }
  | { kind: 'final'; mascot: string };

export const TUTORIAL_STORAGE_KEY = 'bt_tutorial_completed_v1';
export const TUTORIAL_FORCE_KEY = 'bt_tutorial_force_after_signup';

export const STEPS: TutorialStep[] = [
  {
    kind: 'intro',
    mascot:
      'Eaí! Sou o mascote do BoraTrocar. Bora aprender em 30 segundinhos como organizar o seu álbum?',
  },
  {
    kind: 'demo-sticker',
    initialCount: 0,
    expect: ['click'],
    hint: 'Toca na figurinha aí em cima.',
    attentionPulse: true,
    mascot:
      'Essa aí em cima é uma figurinha do álbum. Toca nela pra marcar que você já tirou. Vai ficar verde.',
  },
  {
    kind: 'demo-sticker',
    initialCount: 1,
    expect: ['click'],
    hint: 'Toca de novo.',
    mascot:
      'Tirou outra igual? Toca de novo! Ela vira amarela e mostra que ela é repetida.',
  },
  {
    kind: 'demo-sticker',
    initialCount: 2,
    expect: ['longpress', 'longpress'],
    hint: 'Segura uma vez, depois segura de novo.',
    mascot:
      'Trocou ou errou? Segura a figurinha por meio segundo pra tirar uma. Cada toque longo tira só uma. Bora zerar as duas.',
  },
  {
    kind: 'demo-sticker',
    initialCount: 0,
    expect: ['click', 'click', 'longpress', 'longpress'],
    hint: 'Toca, toca, segura, segura.',
    mascot:
      'Bora praticar: dois toques pra marcar uma repetida, depois segura duas vezes pra zerar.',
  },
  {
    kind: 'navigate',
    tab: 'trocas',
    mascot: 'Boa! Agora vou te mostrar como trocar com a galera na hora.',
  },
  {
    kind: 'highlight',
    tab: 'trocas',
    targetId: 'trocas-qr-buttons',
    mascot:
      'Tá com um amigo do lado? Mostra o seu QR pra ele escanear, ou lê o dele, o app cruza tudo na hora e mostra quem tem o que o outro precisa.',
  },
  {
    kind: 'highlight',
    tab: 'trocas',
    targetId: 'trocas-prioridades',
    mascot:
      'Aqui você marca as figurinhas mais importantes pra você. A galera vê as suas prioridades e sabe quais trocas te ajudam mais.',
  },
  {
    kind: 'navigate',
    tab: 'amigos',
    mascot: 'Por último, a galera.',
  },
  {
    kind: 'highlight',
    tab: 'amigos',
    targetId: 'amigos-gerar-link',
    mascot:
      'Manda esse link pros seus amigos. Quando eles entrarem, você acompanha a coleção deles e combina trocas direto pelo app.',
  },
  {
    kind: 'final',
    mascot:
      'Pronto! Bora completar o álbum. Se esquecer alguma coisa, é só clicar no "?" lá em cima.',
  },
];
